module.exports = __webpack_public_path__ + "static/yay-c3c4cb714d572aad4a6bdac879e73b54.jpg";